module.exports = __webpack_public_path__ + "img/et4.2173c9af.png";